module.exports = __webpack_public_path__ + "img/ic_tripadvisor_color.5f0ffee4.svg";